import React, { useRef, useState } from 'react';
import { SlideProps } from '../SlideHandler';
import { checkMedia } from '../../../componentUtils';
import {
	TourLine,
	VTSlideDescription,
	VTSlideInner,
	VTSlideTitle,
	VTTrailTitle,
	VTVideoContainer,
} from '../virtualTourStyles';
import { BGTest } from '../../../Global/styles';
import { BackgroundTest3 } from '../../../Global/Icons/Icons';
import LoadingVideo from '../../../Global/LoadingVideo/LoadingVideo';

const VideoSlide: React.FC<SlideProps> = ({
	point,
	title,
}) => {
	const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
	const touchHandledRef = useRef(false);
	const video = point.poi_video;

	const handleDescription = () => {
		setIsDescriptionExpanded(prev => !prev);
	};

	const handleDescriptionClick = (
		event: React.MouseEvent<HTMLElement>,
	) => {
		event.stopPropagation();
		if (touchHandledRef.current) {
			touchHandledRef.current = false;
			return;
		}
		handleDescription();
	};

	const handleDescriptionTouchEnd = (
		event: React.TouchEvent<HTMLElement>,
	) => {
		event.stopPropagation();
		event.preventDefault();
		touchHandledRef.current = true;
		handleDescription();
	};

	const handleDescriptionKeyDown = (
		event: React.KeyboardEvent<HTMLElement>,
	) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			handleDescription();
		}
	};

	return (
		<>
			<VTSlideInner>
				<BGTest>
					<BackgroundTest3 />
				</BGTest>

				{title && <VTTrailTitle>{title}</VTTrailTitle>}
				<VTSlideTitle>{point.title}</VTSlideTitle>

				<VTVideoContainer>
					<LoadingVideo src={checkMedia(video)} />
				</VTVideoContainer>
				<VTSlideDescription
					$expanded={isDescriptionExpanded}
					onClick={handleDescriptionClick}
					onTouchEnd={event => handleDescriptionTouchEnd(event)}
					onKeyDown={event => handleDescriptionKeyDown(event)}
					role="button"
					tabIndex={0}
					aria-expanded={isDescriptionExpanded}>
					<div>{point.short_description}</div>
				</VTSlideDescription>
			</VTSlideInner>
			<TourLine />
			{/* <ForwardArrow /> */}
		</>
	);
};

export default VideoSlide;
